// We need jQuery
var $ = window.jQuery;

export default {
  loaded() {
    //check hold state input
    if($('#contact-hold').val() == 1) {
      $('.contact-toggle .btn-success').removeClass('active');
      $('.contact-toggle .btn-danger').addClass('active');
    }
    if($('#contact-hold').val() == 0) {
      $('.contact-toggle .btn-danger').removeClass('active');
      $('.contact-toggle .btn-success').addClass('active');
    }
    $('.contact-toggle .btn').on('click', function(){
      $('.ajax-loading').css('display', 'flex');
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'toggleContact',
          value: {
            contact_id: $('.contact-toggle').data('id'),
            option: $(this).find('input').data('option')
          }
        },
        dataType: 'json',
        success: function(response) {
          $('.ajax-loading').hide();
          if (response.success) {
            //set hold state input
            if(response.state == 1) {
              $('#contact-hold').val(1);
            } else {
              $('#contact-hold').val(0);
            }
          }
        }
      })
    })

    if ($('#agent-hold').val() == 0) {
      $('.future-agent-toggle .btn-success').removeClass('active');
      $('.future-agent-toggle .btn-danger').addClass('active');
    }
    if ($('#agent-hold').val() == 1) {
      $('.future-agent-toggle .btn-danger').removeClass('active');
      $('.future-agent-toggle .btn-success').addClass('active');
    }
    $('.future-agent-toggle .btn').on('click', function () {
      $('.ajax-loading').css('display', 'flex');
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'toggleFutureAgent',
          value: {
            contact_id: $('.future-agent-toggle').data('id'),
            option: $(this).find('input').data('option')
          }
        },
        dataType: 'json',
        success: function (response) {
          $('.ajax-loading').hide();
          if (response.success) {
            //set hold state input
            if (response.state == 1) {
              $('#agent-hold').val(1);
            } else {
              $('#agent-hold').val(0);
            }
          }
        }
      })
    })
  }
}
